<div class="option-item">
	<ng-container *ngIf="path">
		<a class="link-item" [routerLink]="path" [routerLinkActive]="activeClass" [attr.data-link-event]="linkEvent" [ngClass]="classes" [attr.disabled]="disabled">
			<ng-container [ngTemplateOutlet]="menuItemContent"></ng-container>
		</a>
	</ng-container>
	<ng-container *ngIf="!path">
		<span class="link-item" (click)="onMenuItemClick.emit(event)" [attr.data-link-event]="linkEvent" [ngClass]="classes" [attr.disabled]="disabled">
			<ng-container [ngTemplateOutlet]="menuItemContent"></ng-container>
		</span>
	</ng-container>
	<ng-template #menuItemContent>
		<icon *ngIf="icon" [type]="icon"></icon> <span class="icon-caption"> <ng-content></ng-content> </span>
	</ng-template>
</div>
